import { OrganizationKeyName } from "../../../model/Organization";
import { Order } from "../model/OrderSuccessResponse";

export const GET_ORDER_SUCCESS = "SHOP:GET_ORDER_SUCCESS";

export const getOrderSuccessAction = (
  organization: OrganizationKeyName,
  id: string,
  data: Order
) => ({
  type: GET_ORDER_SUCCESS as typeof GET_ORDER_SUCCESS,
  organization,
  id,
  data,
});

export type GetOrderSuccessAction = ReturnType<typeof getOrderSuccessAction>;
